<div class="toast-container">
  @for (toast of toasts; track toast.id) {
    <div class="toast" [class.toast-exit]="!toast.visible">

      
      <div class="toast-glow"></div>


      <div class="toast-icon-wrap">
        <i class="fa-solid fa-bell toast-bell"></i>
        <span class="ping"></span>
      </div>

   
      <div class="toast-body">
        <p class="toast-title">New Order Received!</p>
      
        <p class="toast-time">{{ toast.time }}</p>
      </div>

    
      <button class="toast-close" (click)="dismissToast(toast.id)" title="Dismiss">
        <i class="fa-solid fa-xmark"></i>
      </button>

 
      <div class="toast-progress"></div>

    </div>
  }
</div>
